import {createApp, nextTick} from 'vue'
const axios = require('axios');

export default {
    name: 'form-general',
    _el: null,
    init() {
        this._els = document.querySelectorAll('[data-form]');

        for (const el of this._els) {
            this.run(el);
        }
    },

    run (element)
    {
        const subjectMap = {
            'service': 'Verkstedbestilling',
            'estimation': 'Prisantydning',
            'campaign': 'Kampanje',
            'accessoires': 'Utstyr & tilbehør',
            'caravans': 'Spørsmål om bobil',
            'caravan_trailers': 'Spørsmål om campingvogn',
            'spare_parts': 'Spørsmål om deler',
        }

        const queryString = window.location.search;
        let name    = null;
        let email   = null;
        let message = null;
        if (queryString.search('test=contact') != -1) {
            name    = 'Ola Nordmann';
            email   = 'test@example.com';
            message = 'Testmelding';
        }

        createApp({
            delimiters: ['@{', '}'],
            data()  {
                return {
                    a           : 'contact form',
                    city : null,
                    currentRetailer : null,
                    dateValue: null,
                    email       : '',
                    formType    : '',
                    gdpr        : null,
                    honeypot    : false,
                    host        : "",
                    message     : message,
                    name        : name,
                    phone       : null,
                    product     : null,
                    redirect    : "",
                    reg_number  : null,
                    responseMessage : null,
                    responseStatus : null,
                    retailerId  : "",
                    retailers   : [],
                    street: null,
                    subject     : null,
                    subjectClicked: false,
                    subjectMap: subjectMap,
                    userId      : email,
                    zipcode: null,
                }
            },

            created()
            {
                nextTick(this.initForm);
            },

            methods:
            {
                initForm() {
                    this.host           = document.querySelector('[name="site_root"]').content;
                    this.redirect       = window.location.href;
                    const form = document.querySelector('.form');

                    if (! form) {
                        return false;
                    }

                    form.classList.add('is-ready');

                    if (element.dataset.product && typeof element.dataset.product === 'string') {
                        this.product = JSON.parse(element.dataset.product);
                        delete(element.dataset.product);
                    }

                    if (element.dataset.retailers && typeof element.dataset.retailers === 'string') {
                        this.retailers = JSON.parse(element.dataset.retailers);
                        delete(element.dataset.retailers);                }

                    this.retailerId = element.dataset.retailerid;

                    this.setFormType();
                    this.setCurrentRetailer();
                },

                setCurrentRetailer() {
                    const retailer = this.retailers.filter(r => r.id == this.retailerId);

                    if (typeof retailer === 'object' && typeof retailer[0] === 'object') {
                        this.currentRetailer = retailer[0];
                    }
                },

                setFormType(event) {
                    if(typeof event !== "undefined"){
                        event.target.classList.remove("form-select--disabled");
                        this.formType = event.target.value;
                    } else {
                        this.formType = element.dataset.formtype;
                    }

                    this.setSubject();
                },

                setSubject() {
                    if(element.dataset.subject) {
                        this.subject = element.dataset.subject;
                        return;
                    }

                    this.subject = (this.subjectMap[this.formType]) ?
                         this.subjectMap[this.formType] : "Generelt spørsmål";
                },

                prepareData() {
                    const token = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');

                    const postValues = {
                        city: this.city,
                        email: this.userId,
                        gdpr: (this.gdpr) ? 1 : 0,
                        honeypot: document.getElementById('email').value,
                        message: this.message,
                        name : this.name,
                        phone: this.phone,
                        redirect: this.redirect,
                        reg_number : this.reg_number,
                        retailerId: this.retailerId,
                        street: this.street,
                        subject: this.subject,
                        type: this.formType,
                        zipcode: this.zipcode
                    }

                    if (this.product) {
                        postValues.productId =  this.product.id;
                        postValues.product = this.product.title;
                        postValues.resource = this.product.resource;
                        postValues.daterange = this.dateValue;
                    }

                    const bodyFormData = new FormData();

                    for(let attr in postValues) {
                        bodyFormData.append(attr, postValues[attr]);
                    }

                    return bodyFormData;
                },

                onSubmit(event) {
                    const headers = { "Content-Type": "multipart/form-data" };
                    const postData = this.prepareData();
                    const url = this.host+'actions/mm/mail/store';

                    axios.post(url, postData, headers)
                        .then(this.onSubmit__callback)
                        .catch(this.onSubmit__error);
                },

                onSubmit__callback(response) {
                    if (typeof response === 'object' && typeof response.data === 'object') {
                        this.responseStatus = 'ok';
                        this.responseMessage = response.data.message;
                    }
                },

                onSubmit__error(error) {
                    this.responseStatus = 'error';
                    this.responseMessage = error;
                }
            },
        }).mount(element);
    }

}